import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;

  .title {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    text-align: left;
    width: 100%;
    color: #5c5d61;
  }

  form {
    width: 100%;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .box {
    background-color: #fff;
    height: 47px;
    padding: 14px 16px;
  }

  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 20px;
  }
`;
